import {baseUrl, buildHeaders, getResponseOrThrow} from "../api/common";

export const apiSignUp = (payload) => {
  return fetch(`${baseUrl}/manager`, {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(payload)
  }).then(getResponseOrThrow)
    .then((json) => {
      return Promise.resolve(json);
    })
}
